export default __webpack_public_path__ + "static/angie-jones-28e87e7d8290ed12679a000b5c5a0b1c.jpg";